/**
 * Front route declaration, with their associated component
 * @see {@link https://router.vuejs.org/guide/essentials/named-routes.html|Vue Router Named Route}
 */

import ListingsWrapper from 'vcomponents/listing/ListingsWrapper.vue';
import Listing from 'vcomponents/listing/Listing.vue';
import PipelineListing from 'vcomponents/listing/PipelineListing.vue';

import ClientsListingResolver from 'api/routing/listings/ClientsListingRoutingResolver';
import ProspectsListingResolver from 'api/routing/listings/ProspectsListingRoutingResolver';
import SuppliersListingResolver from 'api/routing/listings/SuppliersListingRoutingResolver';
import ContactsListingResolver from 'api/routing/listings/ContactsListingRoutingResolver';
import OpportunitiesListingResolver from 'api/routing/listings/OpportunitiesListingRoutingResolver';
import PipelineListingResolver from 'api/routing/listings/PipelineListingRoutingResolver';
import CompaniesListingResolver from 'api/routing/listings/CompaniesListingRoutingResolver';
import IndividualsListingResolver from 'api/routing/listings/IndividualsListingRoutingResolver';

import OpportunityOverview from 'api/overview/OpportunityOverview';
import OverviewOpportunity from 'vcomponents/pages/OverviewOpportunity.vue';

import TabActivity from 'vcomponents/overview/tabs/TabActivity.vue';
import TabPipeline from 'vcomponents/overview/tabs/TabPipeline.vue';
import TabInformationsOpportunity from 'vcomponents/overview/tabs/TabInformationsOpportunity.vue';
import TabDocuments from 'vcomponents/overview/tabs/TabDocuments.vue';
import TabCustomfields from 'vcomponents/overview/tabs/TabCustomfields.vue';
import TabBriefcase from 'vcomponents/overview/tabs/TabBriefcase.vue';
import TabListingv1 from 'vcomponents/overview/tabs/TabListingv1.vue';

export default [
    {
        path: '/directory',
        name: 'crm',
        component: ListingsWrapper,
        props: {
            group: 'crm',
        },
        children: [
            {
                path: 'clients',
                name: 'client',
                component: Listing,
                meta: {
                    menuId: 'contacts',
                },
                beforeEnter: (to, from, next) => {
                    const listingResolver = new ClientsListingResolver();
                    listingResolver.feed(to);
                    next();
                },
                props: true,
            },
            {
                path: 'prospects',
                name: 'prospect',
                component: Listing,
                meta: {
                    menuId: 'contacts',
                },
                beforeEnter: (to, from, next) => {
                    const listingResolver = new ProspectsListingResolver();
                    listingResolver.feed(to);
                    next();
                },
                props: true,
            },
            {
                path: 'suppliers',
                name: 'supplier',
                component: Listing,
                meta: {
                    menuId: 'contacts',
                },
                beforeEnter: (to, from, next) => {
                    const listingResolver = new SuppliersListingResolver();
                    listingResolver.feed(to);
                    next();
                },
                props: true,
            },
            {
                path: 'companies',
                name: 'company',
                component: Listing,
                meta: {
                    menuId: 'contacts',
                },
                beforeEnter: (to, from, next) => {
                    const listingResolver = new CompaniesListingResolver();
                    listingResolver.feed(to);
                    next();
                },
                props: true,
            },
            {
                path: 'individuals',
                name: 'individual',
                component: Listing,
                meta: {
                    menuId: 'contacts',
                },
                beforeEnter: (to, from, next) => {
                    const listingResolver = new IndividualsListingResolver();
                    listingResolver.feed(to);
                    next();
                },
                props: true,
            },
            {
                path: 'contacts',
                name: 'people',
                component: Listing,
                meta: {
                    menuId: 'contacts',
                },
                beforeEnter: (to, from, next) => {
                    const listingResolver = new ContactsListingResolver();
                    listingResolver.feed(to);
                    next();
                },
                props: true,
            },
        ],
    },
    {
        path: '/opportunities',
        name: 'opportunities',
        component: Listing,
        meta: {
            title: window.i18n.__('Opportunités'),
            menuId: 'prospection',
        },
        beforeEnter: (to, from, next) => {
            const listingResolver = new OpportunitiesListingResolver();
            listingResolver.feed(to);
            next();
        },
        props: true,
    },
    {
        path: '/opportunities/pipelines',
        name: 'pipeline',
        component: PipelineListing,
        meta: {
            title: window.i18n.__('Opportunités dans le pipeline'),
            menuId: 'prospection',
        },
        beforeEnter: (to, from, next) => {
            const listingResolver = new PipelineListingResolver();
            listingResolver.feed(to);
            listingResolver.getDefaultFunnel().then((response) => {
                to.params.funnel = response;
                next();
            });
        },
        props: true,
    },
    {
        path: '/prospection/opportunities/:id',
        name: 'opportunity.overview',
        component: OverviewOpportunity,
        meta: {
            menuId: 'prospection',
            overviewClass: null,
            forceTitle: true,
        },
        beforeEnter(to, from, next) {
            to.meta.menuId = 'prospection';
            to.meta.overviewClass = new OpportunityOverview();
            next();
        },
        children: [
            {
                path: 'activity',
                alias: '',
                name: 'opportunity.overview.activity',
                component: TabActivity,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'informations',
                name: 'opportunity.overview.informations',
                component: TabInformationsOpportunity,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'documents',
                name: 'opportunity.overview.documents',
                component: TabDocuments,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'customfields',
                name: 'opportunity.overview.customfields',
                component: TabCustomfields,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'proposal',
                name: 'opportunity.overview.proposal',
                component: TabListingv1,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'briefcase',
                name: 'opportunity.overview.briefcase',
                component: TabBriefcase,
                meta: {
                    forceTitle: true,
                },
            },
            {
                path: 'pipeline',
                name: 'opportunity.overview.pipeline',
                component: TabPipeline,
                meta: {
                    forceTitle: true,
                },
            },
        ],
    },
    {
        path: '/rest/opportunity/init/:id',
        name: 'overview.opportunity.init',
    },
];
